import Instance from "../../../../Axios";

// New Actions for the app

const GetPropostasPorResponder =
  (parceirosId, dataInicio, dataFim) => async (dispatch) => {
    await Instance()
      .get(`/energias/dashboard/propostasPorResponder`, {
        params: { parceirosId, dataInicio, dataFim },
      })
      .then(({ data }) => {
        //   console.log(data);
        dispatch({
          type: "GET_PROPOSTAS_POR_RESPONDER",
          payload: data.yData[0].propostas_por_responder,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default GetPropostasPorResponder;
